import React from 'react';

import Button from 'react-bootstrap/Button';

import Spinner from '../Spinner/index.jsx';


class LoadMore extends React.Component {
  constructor(props) {
    super(props);

    this.onClick = this.onClick.bind(this);
  }

  onClick(event) {
    event.preventDefault();

    if (this.props.onClick) {
      this.props.onClick();
    }
  }

  render() {
    var content = [];

    if (this.props.fetching) {
      content.push(
        <div key="loading" className="my-4">
          <Spinner />
        </div>
      );
    }

    content.push(
      <div key="load-more" className="mt-4 text-center">
        <Button disabled={this.props.fetching} onClick={this.onClick}>Load More</Button>
      </div>
    );


    return content;
  }
}


export default LoadMore;

